module.exports = __webpack_public_path__ + "img/openai-account-banned-for-policy-violations.d2c46023.jpeg";